module.exports = __webpack_public_path__ + "static/media/flag_bra.aa1e61da.svg";